import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Close from "@mui/icons-material/Close";

import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { AuthContext } from "../../context/AuthContext";

import DpChange from "./DpChange";
import ModalStyle from "../../data/ModalStyle";

const UserAccount = ({ account }) => {
  const params = useParams();
  const username = params.username;
  const { user } = useContext(AuthContext);

  const [dp, setdp] = useState(null);
  const [croppedimage, setcroppedimage] = useState(null);
  const [logoutmodal, setlogoutmodal] = useState(false);
  const [self, setself] = useState(true);

  const ChangedCover = ({ image }) => {
    if (image) setcroppedimage(URL.createObjectURL(image));
    else setcroppedimage(null);
  };

  const DpChanged = ({ image }) => {
    if (image) setdp(URL.createObjectURL(image));
    else setdp(null);
  };

  useEffect(() => {
    if (username && account && account.username) {
      setself(username === account.username);
    }
  }, [account, username]);

  return (
    <div className="w-100 mt-3 col-12 ">
      <style>{`
        .exact-card {
          background: linear-gradient(120deg, #ffffff, #f2f6ff, #ffffff);
          background-size: 200% 200%;
          animation: gradientMove 6s ease infinite;
          border-radius: 26px;
          padding: 28px 22px 26px; /* more top & bottom */
          display: flex;
          flex-direction: column;  /* center layout for all screens */
          align-items: center;
          gap: 14px;
          box-shadow: 0 14px 34px rgba(0,0,0,0.10);
          border: 1px solid rgba(99,102,241,0.3);
          // max-width: 520px;
          margin: 0 auto; /* center card on large screens */
          text-align: center;
        }

        @keyframes gradientMove {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .dp-wrap {
          position: relative;
          width: 96px;
          height: 96px;
          margin-top: 4px;
        }

        .dp-wrap img {
          width: 96px;
          height: 96px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid transparent;
          background: linear-gradient(#fff, #fff) padding-box,
                      linear-gradient(135deg, #ff7a00, #6366f1) border-box;
          box-shadow: 0 0 0 6px rgba(99,102,241,0.15);
        }

        .profile-text h3 {
          margin: 6px 0 2px;
          font-size: 1.6rem;
          font-weight: 900;
          color: #0f172a;
          letter-spacing: -0.4px;
        }

        .profile-text span {
          font-size: 0.95rem;
          color: #64748b;
        }

        .right-actions {
          width: 100%;
          display: flex;
          justify-content: center;
          gap: 14px;
          margin-top: 18px;
        }

        .right-actions .btn {
          min-width: 160px;
          border-radius: 999px;
          padding: 9px 18px;
          font-size: 0.9rem;
          font-weight: 600;
          border: 1.8px solid #ff7a00;
          color: #ff7a00;
          background: linear-gradient(135deg, rgba(255,122,0,0.08), rgba(255,122,0,0.02));
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all .25s ease;
        }

        .right-actions .btn:hover {
          background: linear-gradient(135deg, #ff7a00, #ff9f43);
          color: #fff;
          transform: translateY(-1px);
          box-shadow: 0 8px 18px rgba(255,122,0,0.35);
        }

        @media (max-width: 576px) {
          .exact-card {
            padding: 22px 14px 22px;
            border-radius: 22px;
          }

          .right-actions {
            gap: 10px;
          }

          .right-actions .btn {
            min-width: unset;
            flex: 1;
            padding: 8px 10px;
            font-size: 0.85rem;
          }
        }

        /* Reduce button sizes specifically for devices between 992px and 1057px
           to avoid the buttons overflowing the card on those widths. Other
           breakpoints remain unchanged. */
        @media (min-width: 992px) and (max-width: 1057px) {
          .right-actions {
            gap: 10px;
          }

          .right-actions .btn {
            min-width: 120px;
            padding: 8px 14px;
            font-size: 0.88rem;
          }
        }
      `}</style>

      <Modal open={logoutmodal} onClose={() => setlogoutmodal(false)}>
        <Box sx={ModalStyle} className="p-3 col-lg-4 col-md-5 col-sm-6 col-11">
          <div className="modal-header">
            <h5>Close Application !</h5>
            <Close className="click" onClick={() => setlogoutmodal(false)} />
          </div>
        </Box>
      </Modal>

      <div className="exact-card">
        <div className="dp-wrap">
          {self ? (
            <DpChange
              DpChanged={({ image }) => DpChanged({ image })}
              account={account}
            />
          ) : (
            <DpChange self={false} account={account} />
          )}
        </div>

        <div className="profile-text">
          {account && (
            <>
              <h3>
                {account.first_name} {account.last_name}
              </h3>
              <span>@{account.username}</span>
            </>
          )}
        </div>

        <div className="right-actions d-flex flex-lg-column flex-xl-row">
          <Link to="/my-courses" className="btn btn-sm">
            <MenuBookIcon fontSize="small" /> My Courses
          </Link>

          <Link to={"/u/" + account.username} className="btn btn-sm">
            <AccountCircleIcon fontSize="small" /> My Account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UserAccount;